/* build/tpl */
import deps from './deps/someDeep.js';
import getSomeDeep from './getSomeDeep.js';
export default getSomeDeep(deps);
